<template>
  <div class="event_transfer">
    <div class="event_transfer_top">
      <IconBase
          icon-name="transfer"
          width="22"
          height="22"
          viewBox="0 0 18 18"
          title="Перенос занятия на"
          :showIconDescription="true"
      >
        <IconTransfer/>
      </IconBase>
    </div>
    <div class="event_transfer_bottom">
      <div class="event_transfer_bottom_date" v-if="transfer && transfer.date && Object.keys(transfer.date).length !== 0">{{formattedDate}}</div>
      <div class="event_transfer_bottom_time">
        <div class="event_transfer_bottom_time_from" v-if="transfer && transfer.time && typeof (transfer.time.start) !== undefined && transfer.time.start !== null">
          {{formattedTimeStart}}
        </div>
        <div class="event_transfer_bottom_time_divider">-</div>
        <div class="event_transfer_bottom_time_to" v-if="transfer && transfer.time && typeof (transfer.time.end) !== undefined && transfer.time.end !== null">
          {{formattedTimeEnd}}
        </div>
      </div>

    </div>
  </div>
</template>

<script>

import IconBase from "@/components/shop/icons/IconBase.vue";
import IconTransfer from "@/components/shop/icons/IconTransfer.vue";

export default {
  name: "EventTransfer",
  components: {
    IconBase,
    IconTransfer
  },
  computed: {
    formattedDate() {
      const dateObj = new Date(this.transfer.date)
      const locale = 'ru-RU'

      const dayMonth = dateObj.toLocaleDateString(locale, {
        day: 'numeric',
        month: 'long'
      })
      const weekday = dateObj.toLocaleString(locale, { weekday: 'long' })

      return `${dayMonth}, ${weekday}`
    },
    formattedTimeStart() {
      return this.transfer.time.start?.slice(0, 5) || ''
    },
    formattedTimeEnd() {
      return this.transfer.time.end?.slice(0, 5) || ''
    }
  },
  props: {
    transfer: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
}
</script>


